/**
 * Die Farben des Spiels — als Datentabelle, wie `materials.ts` es für den
 * Roboter macht.
 *
 * WARUM DAS HIER KEIN VERSTOSS GEGEN DIE GUARD RAIL IST. `CLAUDE.md` verbietet
 * rohe Hex-Werte IN KOMPONENTEN und verlangt semantische Tokens für die
 * Oberfläche. Beides gilt weiter und wird eingehalten: die Anzeige des Spiels
 * (`dash.css`) benutzt ausschliesslich Tokens, und keine Komponente schreibt
 * eine Farbe. Was hier steht, sind Materialfarben einer Three.js-Szene, und die
 * liegen in diesem Projekt seit jeher als Tabelle in der Bühnenschicht — ein
 * `--color-bg-surface` hat für eine Baumkrone keine Bedeutung.
 *
 * WARUM ES TROTZDEM EINE ENTSCHEIDUNG WAR. Die Marke ist zweiregistrig und
 * monochrom; eine grüne Wiese ist keines von beidem. Sie steht hier, weil das
 * Spiel ein BRUCH sein soll: wer sie sieht, hat das Werkzeug verlassen und weiss
 * es sofort. Genau deshalb bleibt sie auch auf das Spiel beschränkt — sie darf
 * in keine Seite, kein Diagramm und keinen Token wandern. Die Bühne setzt beim
 * Beenden alles zurück, was sie hier angefasst hat.
 *
 * Apfelgrün ist der Akzent und nicht der Grund: die Wiese bleibt gedämpft,
 * damit das helle Grün überhaupt trägt. Es sitzt an den Lichtseiten der Kronen
 * und an den Energiezellen — dort, wo es etwas bedeutet.
 */

/** Der Akzent. Zellen und die Lichtseiten der Kronen. */
export const APFEL = 0xa6cf4a

export const WORLD_COLORS = {
  grass: 0x6b8a50,
  path: 0xbcaf8d,
  water: 0x4c87a8,
  bank: 0xb6a981,
  hill: 0x8aa173,
  trunk: 0x6b5137,
  leafDark: 0x3f6b3c,
  leafLight: APFEL,
  rock: 0x8e8b84,
} as const

/** Der Himmel des Spiels — heller Dunst, in den der Nebel ausläuft. */
export const SKY = 0xcce3ee
export const FOG_NEAR = 20
export const FOG_FAR = 62

export const ITEM_COLORS = {
  /** Hürde: warmes Orange, die einzige Warnfarbe im Bild. */
  hurdle: 0xe8863c,
  hurdleGlow: 0x5a2408,
  post: 0x50565c,
  /** Öl: fast schwarz und glatt — es soll wie eine Pfütze lesen, nicht wie ein Loch. */
  oil: 0x121a22,
  /** Riegel: heller Beton mit markierten Kanten. */
  pit: 0x8a9299,
  pitEdge: 0xd8c08a,
  pitEdgeGlow: 0x3a2e10,
  cell: APFEL,
  cellGlow: 0x2e4a0c,
} as const
